"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationLog = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const notification_event_type_entity_1 = require("./notification-event-type.entity");
let NotificationLog = class NotificationLog {
};
exports.NotificationLog = NotificationLog;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)({ name: "id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], NotificationLog.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "event_type_id", type: "int" }),
    tslib_1.__metadata("design:type", Number)
], NotificationLog.prototype, "eventTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)(),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "channel", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)(),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "status", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", String)
], NotificationLog.prototype, "error", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], NotificationLog.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => notification_event_type_entity_1.NotificationEventType),
    (0, typeorm_1.JoinColumn)({ name: 'event_type_id' }),
    tslib_1.__metadata("design:type", typeof (_b = typeof notification_event_type_entity_1.NotificationEventType !== "undefined" && notification_event_type_entity_1.NotificationEventType) === "function" ? _b : Object)
], NotificationLog.prototype, "eventType", void 0);
exports.NotificationLog = NotificationLog = tslib_1.__decorate([
    (0, typeorm_1.Entity)("notification_log")
], NotificationLog);
